import React from 'react';
import { CountryProvider } from 'common/src/contexts/CountryContext';
import { DrawerProvider } from 'common/src/contexts/DrawerContext';
import I18nProvider from './I18nProvider';

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders = ({ children }: AppProvidersProps) => (
  <CountryProvider>
    <DrawerProvider>
      <I18nProvider>{children}</I18nProvider>
    </DrawerProvider>
  </CountryProvider>
);

export default AppProviders;
